import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  rowWithNegativeMargin: {
    flexDirection: 'row',
    marginHorizontal: -theme.spacings.xs,
    gap: theme.spacings.sm,
  },
  container: {
    flex: 1,
    gap: theme.spacings.sm,
    paddingHorizontal: theme.spacings.md,
    marginBottom: theme.spacings.sm,
  },
  headerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerActions: {
    flexDirection: 'row',
    gap: theme.spacings.sm,
    marginLeft: 'auto',
  },
  setContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    rowGap: theme.spacings.md,
    marginBottom: theme.spacings.sm,
  },
  cardColumn: {
    width: '48%',
  },
});
